module.exports = __webpack_public_path__ + "media/common/images/dashboard/life-at-innogy-illustration-big-3893581460bcba4ad0f7e138f3794fdd.svg";